import React from 'react';

import { ADMIN_DASHBOARD } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';

const EditPacketPage = React.lazy(() => import('../../../pages/Admin/ManageDocuments/EditPacketPage'));

export default {
  route: [`/administration/packets/edit/:id`],
  area: ADMIN,
  component: EditPacketPage,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DASHBOARD,
  hasNavBar: true,
};
